import DynamicComponent from "components/DynamicComponent"
import { getPage, getSponsors, getAdvisors, getArticles, getMoments } from "storyblok/api"
import Meta from "components/Meta"
import Hero from "components/Hero"
import Modal from "components/Modal"
import YourStoryForm from "components/YourStoryForm"
import TopMomentsForm from "components/TopMomentsForm"
import SponsorSection from "components/SponsorsSection"
import CardAndBannerSection from "components/CardAndBannerSection"
import WideCardCarousel from "components/WideCardCarousel"
import BigBlueSection from "components/BigBlueSection"
import ThreeCardSection from "components/ThreeCardSection"
import AdvisoryBoard from "components/AdvisoryBoard"
import OurStory from "components/OurStory"

export default function Home({ story, meta, sponsors, advisors, articles, moments }) {
  return (
    <main className="page-content overflow-x-hidden">
      <Meta info={meta} />
      <Hero />
      <Modal isTall fragment="vote-now">
        <TopMomentsForm moments={moments} />
      </Modal>
      <Modal isTall={false} fragment="your-story">
        <YourStoryForm />
      </Modal>
      {
        <CardAndBannerSection
          article={articles?.latest}
          eyebrow="latest"
          bannerHeading="Vote on your Top 5 moments"
          description="Some events resonate profoundly and personally. Vote for the moments on our list that you consider the
                  most transformative!"
          banner_cta_text="VOTE NOW"
          bannerContain="contain"
          banner_cta_link="#vote-now"
          event_name="click_voting_modal"
        />
      }
      {articles?.technology?.length > 0 && (
        <BigBlueSection>
          <WideCardCarousel category="Technology" cards={articles.technology} />
        </BigBlueSection>
      )}
      {articles["from-our-archives"]?.length > 0 && (
        <ThreeCardSection category="From Our Archives" cards={articles["from-our-archives"]} />
      )}

      {(articles.management.length > 0 || articles["pay-benefits"].length > 0) && (
        <BigBlueSection>
          {articles.management.length > 0 && <WideCardCarousel category="Management" cards={articles.management} />}
          {articles["pay-benefits"].length > 0 && (
            <WideCardCarousel category="Pay & Benefits" cards={articles["pay-benefits"]} />
          )}
        </BigBlueSection>
      )}

      {articles["from-our-readers"].length > 0 && (
        <ThreeCardSection category="From Our Audience" cards={articles["from-our-readers"]} />
      )}

      {(articles["pay-benefits"].length > 0 || articles.defense.length > 0) && (
        <BigBlueSection>
          {articles.workforce.length > 0 && <WideCardCarousel category="Workforce" cards={articles.workforce} />}
          {articles.defense.length > 0 && <WideCardCarousel category="Defense" cards={articles.defense} />}
        </BigBlueSection>
      )}

      <CardAndBannerSection
        article={articles?.about}
        eyebrow="2000 - 2025"
        bannerHeading="Tell us your story from the last 25 years"
        description="If it made you laugh, cry or think deeply, we want to hear about it!"
        banner_cta_text="SHARE YOUR STORY"
        banner_cta_link="#your-story"
        bannerContain="cover"
        event_name="click_share_story_modal"
      />
      <SponsorSection sponsors={sponsors} />
      <AdvisoryBoard advisors={advisors} />
      <OurStory />
      <DynamicComponent blok={story?.content} />
      <div type="hidden" style={{ display: "none" }}>
        <form name="top-moments" method="post" netlify data-netlify="true" data-netlify-honeypot="bot-field">
          <input type="hidden" name="bot-field" />
          <input type="checkbox" name="Moments" />

          <input type="submit" value="submit" />
        </form>
      </div>
      <div type="hidden" style={{ display: "none" }}>
        <form name="your-story" method="post" netlify data-netlify="true" data-netlify-honeypot="bot-field">
          <input type="hidden" name="bot-field" />
          <input type="file" name="File" />
          <input type="textarea" name="Story" />
          <input type="checkbox" name="Consent" />

          <input type="submit" value="submit" />
        </form>
      </div>
    </main>
  )
}

export async function getStaticProps({ preview = null }) {
  // home is the default slug for the homepage in Storyblok, but we've aliased it to '/' here and in the visual editor.
  // This template would otherwise be identical to pages/[...slug.js] and therefore unnecessary
  const { page, globals } = await getPage("home", preview)

  const sponsors = await getSponsors()
  const advisors = await getAdvisors()
  const articles = await getArticles()
  const moments = await getMoments()

  return {
    props: {
      // globals,
      story: page ?? null,
      meta: page?.content?.seo ?? null,
      preview,
      advisors: advisors ?? null,
      sponsors: sponsors ?? null,
      articles: articles ?? null,
      moments: moments.DatasourceEntries.items ?? null,
    },
  }
}
